import BulkItem from './BulkItem';

export default class BenchmarkBrand extends BulkItem {
    private imageUrl: string;
    private color: string;

    constructor(id: string, name: string, imageUrl?: string) {
        super(id, name);

        this.imageUrl = imageUrl;
    }

    toString() {
        return this.name;
    }

    toColor(): string {
        return this.color;
    }

    toImageUrl(): string {
        return this.imageUrl;
    }

    // Construct a BenchmarkBrand from an object, checking for properties first.
    public static fromObject(object: any) {
        const allProps = ['id', 'name', 'imageUrl'].every(prop => object.hasOwnProperty(prop));

        if (allProps) {
            return new BenchmarkBrand(object.id, object.name, object.imageUrl);
        }
    }

    get sortValue() {
        return this.name;
    }
}
